import React, { useRef, useEffect, useState, useReducer,useCallback } from 'react';
import ContentEditable from 'react-contenteditable';
import { funcMeta, ExpressionUtils } from './funcMeta';
import { containByScreen, getCursorContext } from './positionHelper';
import Operators from './Operators';
import { cloneDeep, isEmpty, isString, debounce } from 'lodash';
import classes from './FormulaBuilder.module.css';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { useFormik } from 'formik';
import Popper from '@material-ui/core/Popper';
import * as Yup from 'yup';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as ArchitectActions from '../../../actions/architectActions';
import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';
import * as BasAgentActions from '../../../actions/basAgentActions';
import * as DeviceActions from '../../../actions/deviceActions';
import * as UiActions from '../../../actions/uiActions';
import * as SensorTypeActions from '../../../actions/sensorTypeActions';
import queryString from 'query-string';
import * as EquipmentTypeActions from '../../../actions/equipmentTypeActions';
import * as K2ACoreActions from '../../../actions/k2aCoreActions';
import AutoComplete  from '@material-ui/lab/Autocomplete';
import BobModal from '../../../components/BobModal';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ClickAwayListener } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import AutoComplete1 from '../../../components/FormFields/Autocomplete';
import { fetchEquipmentTypesLookup } from '../../../actions/lookupActions';
import * as reportingActions from '../../../actions/reportingActions';

const FormulaBuilder = ({
    activeFormula,
    activeTemplate,
    navEquipment,
    sensorTypes,
    fetchSensorTypes,
    clonedFormula,
    activeNavSite,
    selectedCalculation,
    fetchReportSensorsbyEquipment,
    fetchTemplateDetails,
    fetchTemplateSensorById,
    activeNavEquipment,
    fetchSystemsBySiteId,
    navSites,
    fetchConfigEntitesBySiteId,
    entitySensors,
    configEntities,
    fetchEquipmentTypesLookup,
    fetchCoreEquipment,
    isCustom,
    activeNavCompany,
    equipment,
    equipmentTypes,
    history,
    selectedTemplate,
    setIsValidFormula,
    setExternalSensors,
    externalSensors,
    ...props
}) => {
    const queryValues = queryString.parse(history.location.search);
    const systemId = queryValues.system;
    const siteId = queryValues.site;
    // eslint-disable-next-line no-unused-vars
    const [systems, setSystems] = useState([]);
    const [loading, setLoading] = useState(false);
    const text = useRef(' ');
    const extSensor = useRef(null);
    const innerEditor = useRef(null);
    const ktitle = useRef(null);
    const knode = useRef(null);
    const currentFragment = useRef(null);
    const [esensors,setEsensors] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isSensorOpen, setIsSensorOpen] = useState(false);
    const [isDayOpen, setIsDayOpen] = useState(false);
    const [isHourOpen, setIsHourOpen] = useState(false);
    const [isMinuteOpen, setIsMinuteOpen] = useState(false);
    const [variableList, setVariableList] = useState(['A', 'B']);
    const weekList = ['Sunday', 'Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    const [externalSensorOpen,setExternalSensorOpen] = useState(false);
    const [equipment1Types, setEquipment1Types] = useState([]);
    const timeList = ['12 AM','1 AM','2 AM','3 AM','4 AM','5 AM','6 AM','7 AM','8 AM','9 AM','10 AM','11 AM','12 PM','1 PM','2 PM','3 PM','4 PM','5 PM','6 PM','7 PM','8 PM','9 PM','10 PM','11 PM'];
    // eslint-disable-next-line no-unused-vars
    const [ignored, forceUpdate] = useReducer(x => x + 1, 0);
    const [filteredEquipments,setFilteredEquipments] = useState([]);
    const [filteredSensorTypes,setFilteredSensorTypes] = useState([]);
    const [filteredExtSensorTypes,setFilteredExtSensorTypes] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [entities, setEntities] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState({});
    const [autoCompleteValue, setAutoCompleteValue] = useState('');
    const [activeTemplateId, setActiveTemplateId] = useState('');
    const [contentEditableHtml, setContentEditableHtml] = useState('');
    
    const getMinutes = () => {
        let mins = [];
        for (let i = 0; i <= 60; i++) {
            if (i < 10) {
                mins.push('0' + i);
            }
            else {
                mins.push('' + i);
            } 
        }
        return mins;
    };
    const minuteList = getMinutes();
    const ValidationSchema = Yup.object().shape({
        name: Yup.string()
            .required(),
        templateName: Yup.string()
            .required(),
        parent: Yup.string()
            .required(),
        type: Yup.string()
            .required(),
        equipment: Yup.string()
            .required(),
        equipmentType: Yup.string()
            .required()
    });
    const [initialValues, setInitialValues] = useState({
        name:          '',
        templateName:  '',
        type:          '',
        site:          activeNavSite ? activeNavSite.id : '',
        equipment:     '',
        equipmentType: activeNavEquipment.id && activeNavEquipment.equipmentType ? activeNavEquipment.equipmentType.id : '',
        parent:        activeNavEquipment.id ? activeNavEquipment.id : '',
    });

    useEffect(() => {
        if ( activeNavEquipment && activeNavEquipment.id && sensorTypes && sensorTypes.length > 0 ) {
            let sensorTypeIds = new Set();
            if ( activeNavEquipment.extendedData && activeNavEquipment.extendedData.sensors) {
                for (let sensor of activeNavEquipment.extendedData.sensors) {
                    sensorTypeIds.add(sensor.sensorTypeId);
                }
            }
            if (props.filterSensorTypes) {
                props.filterSensorTypes(sensorTypeIds);
            }
            let filteredSensor = sensorTypes[0].items.filter(c => sensorTypeIds.has(c.id));
            setFilteredSensorTypes(filteredSensor);
        }
    }, [sensorTypes]);

    const filterSensorTypes = (eq) => {
        if (props.setExternalEquipment) {
            props.setExternalEquipment(eq);
        }
        if (eq && eq.id && sensorTypes && sensorTypes.length > 0) {
            let sensorTypeIds = new Set();
            if (eq.extendedData && eq.extendedData.sensors) {
                for (let sensor of eq.extendedData.sensors) {
                    sensorTypeIds.add(sensor.sensorTypeId);
                }
            }
           
            let filteredSensor = sensorTypes[0].items.filter(c => sensorTypeIds.has(c.id));
            filteredSensor.forEach(item => {
                item.equipmentId = eq.id;
                item.siteId = eq.extendedData.site[0].id;
            });
            setFilteredExtSensorTypes([{items: Array.from(filteredSensor)}]);
        }
    };

    let formVal = {
        initialValues:      initialValues,
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
        }
    };

    const formik = useFormik(formVal);

    const handleTitleChange = (event) => {
        props.syncTitle(event.target.value);
        formik.handleChange(event);
    };

    useEffect(() => {
        const init = async () => {         
            await fetchEquipmentTypesLookup();           
            const fetchedSystems = await fetchSystemsBySiteId(siteId);
            setSystems(fetchedSystems);
            setInitialValues({
                ...initialValues,
                parent: systemId || ''
            });
        };

        if (systemId && !isEmpty(activeNavSite)) init();
    }, [activeNavSite]);

    //setting initial focus
    useEffect(() => {
        placeCaretAtEnd(innerEditor.current);
    }, []);

    const handleSiteChange = event => {
        formik.handleChange(event);
        formik.setFieldValue('site', event.target.value, false);
        let val = initialValues;
        val.site = event.target.value;
        setInitialValues(val);
        loadSites(event.target.value);
    };

    const setActiveSite = () => {
        const init = async () => {
            await fetchConfigEntitesBySiteId(activeNavSite.id, {extendedData: true, page: 1, limit: 1000 });
        };
      
        if (formik.values.site !== activeNavSite.id ) {
            formik.setFieldValue('site', activeNavSite.id, false);
            if (activeNavSite.id) init();
        }
    };

    useEffect(() => {
        const init = async () => {
            await fetchConfigEntitesBySiteId(activeNavSite.id, {extendedData: true, page: 1, limit: 1000 });
        };

        if (activeNavSite.id) init();
    }, [activeNavSite]);

    const loadSites = async site => {
        await fetchConfigEntitesBySiteId(site, {extendedData: true, page: 1, limit: 1000 });
    };

    const filterEntities = async value => {
        setLoading(true);
        if (!isEmpty(value)) {
            await fetchConfigEntitesBySiteId(activeNavSite.id, { searchFilter: value,extendedData: true, page: 1, limit: 1000 });
        } else {
            await fetchConfigEntitesBySiteId(activeNavSite.id,{extendedData: true, page: 1, limit: 1000 });
        }
        setLoading(false);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'nav-select-popover-sensor' : undefined;

    const debouncedFetch = useCallback(
        debounce(value => {
            filterEntities(value);
        }, 700),
        []
    );

    useEffect(() => {
        const entities = [...configEntities];
        setEntities(entities);
    }, [configEntities]);

    useEffect(() => {
        setEquipment1Types([...equipmentTypes]);
    }, [equipmentTypes]);

    useEffect(() => {
        let eq = equipment.filter(c => c.equipmentType.id === formik.values.equipmentType);
        setFilteredEquipments(eq);
    }, [equipment]);
 
    useEffect(() => {
        const trackEnter = (e) => {
            if (e.keyCode === 13 && e.target.classList.contains('variable-input')) {
                let val = e.target.value;
                setIsOpen(false);
                if (variableList.indexOf(val) === -1) {
                    setVariableList([val, ...variableList]);
                }
                variableClicked(val,'.please-choose-token');
                document.querySelector('.variable-input').value = '';
            }
        };

        document.addEventListener('keydown', trackEnter);
        return () => {
            document.removeEventListener('keydown', trackEnter);
        };
    }, []);

    useEffect(() => {
        const trackEnter = (e) => {
            if (e.keyCode !== 46 && e.keyCode !== 8 && !(e.target && e.target.classList && e.target.classList.contains('formula-textbox'))) {
                e.preventDefault();
            }
        };
        if ( document.getElementById('formula-editor')) {
            document.getElementById('formula-editor').addEventListener('keydown', trackEnter);
        }
        return () => {
            if ( document.getElementById('formula-editor')) {
                document.getElementById('formula-editor').removeEventListener('keydown', trackEnter);
            }
        };
    }, []);

    const getAllElementsWithAttribute = (attribute) => {
        // var matchingElements = [];
        var allElements = document.querySelectorAll(attribute);
        for (var i = 0, n = allElements.length; i < n; i++) {
            if (allElements[i].getAttribute('ktitle') === ktitle.current) {
                // Element exists with attribute. Add to array.
                return allElements[i].outerHTML;
            }
        }
        return '';
    };

    const getAllElementsWithAttribute1 = (attribute) => {
        // var matchingElements = [];
        var allElements = document.querySelectorAll(attribute);
        for (var i = 0, n = allElements.length; i < n; i++) {
            if (allElements[i].getAttribute('data-ukey') === knode.current) {
                // Element exists with attribute. Add to array.
                return allElements[i].outerHTML;
            }
        }
        return '';
    };

    const fetchEquipments = async (equipmentTypeId) => {
        await fetchCoreEquipment(activeNavCompany.id, { equipmentTypeId: equipmentTypeId });
    };

    const handleDisplayUnitChange = (event, value) => {
        let key = value ? value.id : '';
        formik.setFieldValue('equipmentType', key, true);
        fetchEquipments(key);
    };

    const handleEquipmentChange = (event, value) => {
        let key = value ? value.id : '';
        formik.setFieldValue('parent', key, true);
        let eq = filteredEquipments.find(c => c.id === key);
        let sensorTypeIds = new Set();
        if (eq && eq.extendedData && eq.extendedData.sensors) {
            for (let sensor of eq.extendedData.sensors) {
                sensorTypeIds.add(sensor.sensorTypeId);
            }
        }
        if (props.filterSensorTypes) {
            props.filterSensorTypes(sensorTypeIds);
        }
        let filteredSensor = sensorTypes[0].items.filter(c => sensorTypeIds.has(c.id));
        setFilteredSensorTypes(filteredSensor);
    };


    const variableClicked = (item, className) => {
        let key = '<span ktitle="' + item + '" data-ui-variable="' + item + '" class="variable-token please-choose-token1">' + item + '</span>';
        let token = getAllElementsWithAttribute(className);
        if (token === '') {
            token = getAllElementsWithAttribute('.please-choose-token1');
        }
        text.current = text.current.replace(token, key);
        setContentEditableHtml(contentEditableHtml.replace(token, key));
        forceUpdate();
    };

    const sensorClicked = (id, item, className) => {
        let uid = getRandom();
        let key = '<span data-ui-variable="' + id + '" data-ukey="' +  uid + '" class="variable-token please-choose-sensor">' + item + '</span>';
        let token = getAllElementsWithAttribute1(className);
        text.current = text.current.replaceAll(token, key);
        setContentEditableHtml(contentEditableHtml.replaceAll(token, key));
        forceUpdate();
    };

    const externalsensorClicked = (id, item, siteId, equipmentId, className) => {
        let uid = getRandom();
        let key = '<span data-external="true" data-ui-variable="' + id + '" data-ukey="' + uid + '" data-siteId="' + siteId + '" data-equipmentId="' + equipmentId + '" class="variable-token please-choose-sensor">' + item + '*</span>';
        let token = getAllElementsWithAttribute1(className);
        text.current = text.current.replaceAll(token, key);
        setContentEditableHtml(contentEditableHtml.replaceAll(token, key));
        forceUpdate();
    };

    const openExternalSensorModal = () => {
        extSensor.current = null;
        formik.setFieldValue('sensorType1', selectedCalculation?.sensorType, true);
        setExternalSensorOpen(true);
        setActiveSite();
    };

    const handleConfirmation = () => {
        setExternalSensorOpen(false);
    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const submitFormula = () => {
        setExternalSensorOpen(false);
        if (extSensor.current) {
            let sTypes = filteredSensorTypes;
            sTypes.push(extSensor.current);
            setFilteredSensorTypes(sTypes);
            externalsensorClicked(extSensor.current.id, extSensor.current.name, extSensor.current.siteId, extSensor.current.equipmentId, '.please-choose-sensor');
        }
    };

    const handleSensorTypeChange1 = event => {
        formik.setFieldValue('sensorType1', event.target.value, true);

        const init = async () => {
            if (!isEmpty(selectedEntity) && !isEmpty(event.target.value)) {
                let promises = [];
                promises.push(fetchReportSensorsbyEquipment([selectedEntity.id], [event.target.value.id]));
                Promise.all(promises.map(p => p.catch(err => err)));
            }
        };

        formik.setFieldValue('sensor', null, true);
        formik.handleChange(event);
        init();
    };

    const handleSensorChange1 = event => {
        // const {value} = event.target;
        extSensor.current = event.target.value;
        formik.setFieldValue('sensor', event.target.value, true);
        formik.handleChange(event);
    };

    const clearSearch = () => {
        setAutoCompleteValue('');
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEntityChange = item => {
        setAutoCompleteValue(item.name);
        setSelectedEntity(item);
        handleClose();
        filterSensorTypes(item);
        formik.setFieldValue('sensorType', null, true);
    };

    const handleEntityChangeSensor = item => {
        const init = async (item) => {
            if (formik.values.sensorType1 && formik.values.sensorType1.id) {
                let promises = [];
                promises.push(fetchReportSensorsbyEquipment([item.id], [formik.values.sensorType1.id]));
                Promise.all(promises.map(p => p.catch(err => err)));
            }
        };

        setAutoCompleteValue(item.name);
        setSelectedEntity(item);
        handleClose();
        filterSensorTypes(item);
        formik.setFieldValue('sensorType', null, true);
        formik.setFieldValue('sensorType1',null, true);
        formik.setFieldValue('sensor', null, true);
        init(item);
    };

    useEffect(() => {
        if (entitySensors.spaceAirSensors && entitySensors.spaceAirSensors.length > 0 ) {
            setEsensors(entitySensors.spaceAirSensors.map(c => ({
                id:   c.sensorid,
                name: c.sensorName
            })));
        }
        else {
            setEsensors([]);
        }
    }, [entitySensors]);

    const handleSensorTypeChange = event => {
        // const {value} = event.target;
        formik.handleChange(event);
        extSensor.current = event.target.value;
    };

    useEffect(() => {
        const handleClickAnywhere = (e) => {
            syncModelVal();
            var container = document.querySelector('.menu-visible-formula');
            if (container && !container.contains(e.target)) {
                setIsOpen(false);
            }
            else {
                if (e.target.classList.contains('menu-item') && !e.target.classList.contains('menu-item-sensor')) {
                    setIsOpen(false);
                    let item = e.target.textContent;
                    variableClicked(item, '.please-choose-token');
                }
            }

            var containerSensor = document.querySelector('.menu-visible-sensor');
            if (containerSensor && !containerSensor.contains(e.target)) {
                setIsSensorOpen(false);
            }
            else {
                if (e.target.classList.contains('menu-item-sensor')) {
                    let key = e.target.getAttribute('data-id');
                    if (key === 'add') {
                        openExternalSensorModal();
                    }
                    else {
                        setIsSensorOpen(false);
                        let item = e.target.textContent;
                        sensorClicked(key,item, '.please-choose-sensor');
                    }
                }
            }

            var containerWeek = document.querySelector('.menu-cont-week');
            if (!containerWeek.contains(e.target)) {
                setIsDayOpen(false);
            }
            else {
                if (e.target.classList.contains('menu-item')) {
                    setIsDayOpen(false);
                    let item = e.target.textContent;
                    variableClicked(item, '.dayofweek');
                }
            }

            var containerHour = document.querySelector('.menu-cont-hour');
            if (!containerHour.contains(e.target)) {
                setIsHourOpen(false);
            }
            else {
                if (e.target.classList.contains('menu-item')) {
                    setIsHourOpen(false);
                    let item = e.target.textContent;
                    variableClicked(item, '.hourofday');
                }
            }

            var containerMinute = document.querySelector('.menu-cont-minute');
            if (!containerMinute.contains(e.target)) {
                setIsMinuteOpen(false);
            }
            else {
                if (e.target.classList.contains('menu-item')) {
                    setIsMinuteOpen(false);
                    let item = e.target.textContent;
                    variableClicked(item, '.timeofday');
                }
            }
        };

        document.addEventListener('mouseup', handleClickAnywhere);
        return () => {
            document.removeEventListener('mouseup', handleClickAnywhere);
        };
    }, []);

    useEffect(() => {

        const handlePopup = (e, key) => {
            currentFragment.current = e.target.getAttribute('unique-key');
            let cursor = getCursorContext();
            positionMenuAtCaret(document.querySelector(key), cursor, '');
        };

        const handleClick = (e) => {
            syncModelVal();
            if (e.target.classList.contains('please-choose-token')) {
                handlePopup(e, '.menu-cont');
                ktitle.current = e.target.getAttribute('ktitle');
                setIsOpen(true);
            }
            if (e.target.classList.contains('please-choose-token1')) {
                handlePopup(e, '.menu-cont');
                ktitle.current = e.target.getAttribute('ktitle');
                setIsOpen(true);
            }
            else if (e.target.classList.contains('please-choose-sensor')) {
                handlePopup(e, '.menu-cont-sensor');
                ktitle.current = e.target.getAttribute('data-ui-variable');
                knode.current = e.target.getAttribute('data-ukey');
                setIsSensorOpen(true);
            }
            else if (e.target.classList.contains('dayofweek')) {
                handlePopup(e, '.menu-cont-week');
                setIsDayOpen(true);
            }
            else if (e.target.classList.contains('hourofday')) {
                handlePopup(e, '.menu-cont-hour');
                setIsHourOpen(true);
            }
            else if (e.target.classList.contains('timeofday')) {
                handlePopup(e, '.menu-cont-minute');
                setIsMinuteOpen(true);
            }
        };
        document.querySelector('.ccb-editor-container').addEventListener('click', handleClick);

        return () => {
            if (document.querySelector('.ccb-editor-container')) {
                document.querySelector('.ccb-editor-container').removeEventListener('click', handleClick);
            }
        };
    }, []);

    const insertSensorTokens = (token) => {
        let template = token;
        template = template.replace(/\u00A0/g, '');
        let matches = template.match(/ *\([^)]*\) */g);
        if (matches && matches.length > 0) {
            matches = matches.map(c => c.trim()).map(c => c.substring(1, c.length-1));
            matches = Array.from(new Set(matches));
            for (let d of matches) {
                template = template.replaceAll('('+d+')', '(' + getPleaseChooseSensor(d) + ')');
            }
        }
        return template;
    };

    const printSubsInDelimiters = (str) => {
        let data = [];
        // Stores the indices of
        let dels = [];
        for (let i = 0; i < str.length; i++) {
            // If opening delimiter
            // is encountered
            if (str[i] === '[')
            {
                dels.push(i);
            }
 
            // If closing delimiter
            // is encountered
            else if ((str[i] === ']') &&
                     (dels.length > 0))
            {
                // Extract the position
                // of opening delimiter
                let pos = dels[dels.length - 1];
 
                dels.pop();
 
                // Length of substring
                let len = i - 1 - pos;
 
                // Extract the substring
                let ans;
                ans = str.substring(pos + 1, len + pos + 1);
                data.push(ans);
            }
        }
        return data;
    };

    const insertTemplateTokens = (token, templateSensors) => {
        let template = token;
        template = template?.replace(/\u00A0/g, '');
        let matches = template ? printSubsInDelimiters(template) : null;
        for (let i = 0; i < matches.length; i++) {
            const templateSelected = templateSensors[i];
            const sensor = sensorTypes[0].items.find(s => s.id === templateSelected.id);
            const label = getPleaseChooseTemplate(sensor, templateSelected.isExternalSensor, templateSelected.siteId, templateSelected.equipmentId);
            template = template.replace('sensors["' + templateSelected.id + '"]', label);
        }
        return template?.replace('return ', '');
    };

    const insertSensorTokens1 = async (token) => {
        if (isEmpty(selectedTemplate))
            return;

        const templateSensors = cloneDeep(selectedTemplate.sensors);
        let template = cloneDeep(token);
        template = template?.replace(/\u00A0/g, '');
        let sensors = activeNavEquipment && activeNavEquipment.extendedData ? activeNavEquipment.extendedData.sensors : [];
        let matches = template ? printSubsInDelimiters(template) : null;
        let constMatches = template ? template.match(/\{(.*?)\}/g) : null;

        for (let i = 0; i < matches.length; i++) {
            const selectedId = matches[i].replace(/\\"/g, '"').replaceAll('"', '');
            const templateSelected = templateSensors[i];
            let sensor = sensors.find(s => s.id === selectedId); //sensorTypes[0].items.find(s => s.id === templateSelected.id);
            if (!sensor) {
                const fetchedSensor = await fetchTemplateSensorById(selectedId);
                sensor = fetchedSensor;
            }
            const label = getPleaseChooseTemplate(sensor, templateSelected.isExternalSensor, templateSelected.siteId, templateSelected.equipmentId);
            template = template.replace('sensors["' + selectedId + '"]', label);
        }

        if (!isEmpty(constMatches)) {
            constMatches.forEach(item => {
                let val = item.replace('{', '');
                val = val.replace('}', '');

                let key = getRandom();
                template = template.replace(item, getConstantToken(key, val));
            });
        }
        return template?.replace('return ', '');
    };

    const insertSensorTokens2 = async token => {
        const templateSensors = cloneDeep(selectedTemplate.sensors);
        let template = cloneDeep(token);
        template = template?.replace(/\u00A0/g, '');
        let sensors = activeNavEquipment && activeNavEquipment.extendedData ? activeNavEquipment.extendedData.sensors : [];

        let matches = template ? printSubsInDelimiters(template) : null;
        let constMatches = template.match(/\{(.*?)\}/g);

        for (let i = 0; i < matches.length; i++) {
            const selectedId = matches[i].replace(/\\"/g, '"').replaceAll('"', '');
            const templateSelected = templateSensors[i];
            let sensor = sensors.find(s => s.id === selectedId); //sensorTypes[0].items.find(s => s.id === templateSelected.id);
            if (!sensor) {
                template = template.replace('sensors["' + selectedId + '"]', getPleaseChooseSensorName(null, templateSelected.isExternalSensor, templateSelected.siteId, templateSelected.equipmentId));
            }
            else {
                const label = getPleaseChooseTemplate(sensor, templateSelected.isExternalSensor, templateSelected.siteId, templateSelected.equipmentId);
                template = template.replace('sensors["' + selectedId + '"]', label);
            }
        }

        if (!isEmpty(constMatches)) {
            constMatches.forEach(item => {
                let val = item.replace('{', '');
                val = val.replace('}', '');

                let key = getRandom();
                template = template.replace(item, getConstantToken(key, val));

                const trackEnter = (e) => {
                    let id = e.target.id;
                    document.getElementById(id).setAttribute('value', e.target.value);
                };

                setTimeout(() => {
                    let textbx = document.getElementById(key);
                    if (textbx) {
                        textbx.focus();
                    }
                    textbx.addEventListener('input', trackEnter);
                }, 300);
            });
        }

        return template?.replace('return ', '');
    };

    const insertFormulaTokens = token => {
        let template = token;
        template = template.replace(/\u00A0/g, '');
        let matches = template.match(/ *\([^)]*\) */g);
        if (matches && matches.length > 0) {
            matches = matches.map(c => c.trim()).map(c => c.substring(1, c.length - 1));
            matches = Array.from(new Set(matches));
            for (let d of matches) {
                const selectedId = d.replaceAll('"', '').replaceAll('\'', '');
                if (selectedId !== '') {
                    template = template.replaceAll('(' + d + ')', '(' + getPleaseChooseVariable(selectedId) + ')');
                }
            }
        }
        return template;
    };

    useEffect(() => {
        formik.setFieldValue('name', '');
        props.syncTitle('');
    }, [clonedFormula]);

    useEffect(() => {
        const init = async () => {
            if (activeFormula) {
                //Edit
                if (activeFormula.id) {
                    text.current = props.mode === 'template' ? insertSensorTokens(activeFormula.template) : insertFormulaTokens(activeFormula.template);
                    setContentEditableHtml(props.mode === 'template' ? insertSensorTokens(activeFormula.template) : insertFormulaTokens(activeFormula.template));
                    formik.setFieldValue('name', activeFormula.name);
                    formik.setFieldTouched('name', true);
                    props.syncTitle(activeFormula.name, 'formula');
                }
                //New Formula
                else {
                    text.current = activeFormula.template;
                    setContentEditableHtml(activeFormula.template);
                    if (props.mode === 'template') {
                        formik.setFieldValue('templateName', activeFormula.name);
                        formik.setFieldValue('type', '');
                        formik.setFieldValue('equipment', '');
                        props.syncTitle(activeFormula.name);
                    }
                    else {
                        formik.setFieldValue('name', activeFormula.name);
                        formik.setFieldTouched('name', true);
                        props.syncTitle(activeFormula.name);
                    }
                }
            }
        };

        init();
    }, [activeFormula]);

    useEffect(() => {
        const init = async () => {
            if (!isEmpty(selectedTemplate)) {
                if (selectedTemplate.id !== activeTemplateId && (selectedCalculation && activeTemplateId)) {
                    const selectedFormula = await insertSensorTokens2(selectedTemplate.formulaCode);
                    if (selectedFormula) {
                        text.current = selectedFormula;
                        setContentEditableHtml(selectedFormula);
                    }
                    setActiveTemplateId(selectedTemplate.id);
                } else if (isEmpty(selectedCalculation)) {
                    const selectedFormula = await insertSensorTokens2(selectedTemplate.formulaCode);
                    if (selectedFormula) {
                        text.current = selectedFormula;
                        setContentEditableHtml(selectedFormula);
                    }
                    setActiveTemplateId(selectedTemplate.id);
                }
                else {
                    setActiveTemplateId(selectedCalculation?.sensorCalculationId);
                    const selectedFormula = await insertSensorTokens1(selectedCalculation.sensorCalculation);
                    if (selectedFormula && isString(selectedFormula)) {
                        text.current = selectedFormula;
                        setContentEditableHtml(selectedFormula);
                    }
                }
            }
            else {
                setActiveTemplateId(selectedCalculation?.sensorCalculationId);
                const selectedFormula = insertSensorTokens1(selectedCalculation.sensorCalculation);
                if (selectedFormula && isString(selectedFormula)) {
                    text.current = selectedFormula;
                    setContentEditableHtml(selectedFormula);
                }
            }

        };
        if (!isEmpty(selectedCalculation)) init();

    }, [selectedCalculation, selectedTemplate]);

    useEffect(() => {
        if (activeTemplate) {
            //Edit
            if (activeTemplate.id) {
                text.current = insertTemplateTokens(activeTemplate.formulaCode, activeTemplate.sensors);
                setContentEditableHtml(insertTemplateTokens(activeTemplate.formulaCode, activeTemplate.sensors));
                formik.setFieldValue('templateName',activeTemplate.mode === 'clone' ? '' : activeTemplate.name);
                formik.setFieldTouched('templateName',true);
                formik.setFieldValue('type','Unassigned');
                formik.setFieldTouched('type',false);
                props.syncTitle(activeTemplate.mode === 'clone' ? '' : activeTemplate.name);
            }
        }
    }, [activeTemplate]);

    const handleChange = evt => {
        text.current = evt.target.value;
        setContentEditableHtml(evt.target.value);
    };

    const handleBlur = () => {
    // setIsFocus(false);
    };

    const handleFocus = () => {
    //setIsFocus(true);
    };

    const getRandom = () => {
        return Math.round(1 + Math.random() * 999);
    };

    const getPleaseChooseToken = (highlight) => {
        let key = getRandom();
        if (highlight) {
            return '&nbsp;<span ktitle="' + key + '" unique-key="' + key + '" class="' + ExpressionUtils.pleaseChooseTokenClass + ' ' + ExpressionUtils.highlightTokenClass + '"></span>&nbsp;';
        } else {
            return '&nbsp;<span class="' + ExpressionUtils.pleaseChooseTokenClass + '"></span>&nbsp;';
        }
    };

    const getVariableToken = (key) => {
        return '&nbsp;<input id="' + key + '" autofocus="on" type="number" class="MuiInputBase-input formula-textbox"/> &nbsp;';
    };

    const getConstantToken = (key, value) => {
        return '&nbsp;<input id="' + key + '" value="' + value + '" autofocus="on" type="number" class="MuiInputBase-input formula-textbox"/> &nbsp;';
    };

    const getPleaseChooseSensor = (d) => {
        let key = getRandom();
        if (d) {
            return '&nbsp;<span ktitle="Select Sensor Type ' + d + '" data-ui-variable="' + key + '" data-ukey="' + key + '" class="' + ExpressionUtils.pleaseChooseSensorClass + '"></span>&nbsp;';
        }
        else return '&nbsp;<span ktitle="Select Sensor Type" data-ui-variable="' + key + '" data-ukey="' + key + '" class="' + ExpressionUtils.pleaseChooseSensorClass + '"></span>&nbsp;';
    };

    const getPleaseChooseSensorName = (d) => {
        let key = getRandom();
        if (d) {
            return '&nbsp;<span ktitle="Select Sensor ' + d + '" data-ui-variable="' + key + '" data-ukey="' + key + '" class="' + ExpressionUtils.pleaseChooseSensorClass + '"></span>&nbsp;';
        }
        else return '&nbsp;<span ktitle="Select Sensor" data-ui-variable="' + key + '" data-ukey="' + key + '" class="' + ExpressionUtils.pleaseChooseSensorClass + '"></span>&nbsp;';
    };

    const getPleaseChooseTemplate= (d, isExternal, siteId, equipmentId) => {
        let key = getRandom();
        let externalsensor = isExternal || false;

        let ext = externalsensor ? '*' : '';
        return '&nbsp;<span data-external="'+ externalsensor + '" data-ui-variable="' + d.id +  '" data-ukey="' + key + '" data-siteId="' + siteId + '" data-equipmentId="' + equipmentId + '" class="variable-token please-choose-sensor">' + d.name + ext + '</span>&nbsp;';
    };

    const getPleaseChooseVariable= (d) => {
        return '&nbsp;<span ktitle="' + d + '"data-ui-variable="' + d + '" class="variable-token please-choose-token1">' + d + '</span>&nbsp;';
    };

    const getDayOfWeek = (highlight) => {
        return '&nbsp;<span unique-key="' + getRandom() + '" class="' + ExpressionUtils.dayOfWeek + '"></span>&nbsp;';
    };

    const getHourOfDay = (highlight) => {
        return '&nbsp;<span unique-key="' + getRandom()+ '" class="' + ExpressionUtils.hourOfDay + '"></span>&nbsp;';
    };
    const getTimeOfDay = (highlight) => {
        return '&nbsp;<span unique-key="' + getRandom()+ '" class="' + ExpressionUtils.timeOfDay + '"></span>&nbsp;';
    };

    const getFunctionPlaceholder = (funcName) => {
        let funcName1 = funcName;
        var funcTypes = funcMeta.functionTypes;
        var noOfArgs = 0;
        for (var i = 0; i < funcTypes.length; i++) {
            // eslint-disable-next-line no-loop-func
            let funcDef = funcTypes[i].functions.filter(x => x['function'] === funcName1)[0];
            if (funcDef) {
                noOfArgs = funcDef.argsLength;
                break;
            }
        }

        if (noOfArgs === 'n') {
            noOfArgs = 2;
            funcName1 = funcName1 + ' (n)';
        }
        else  noOfArgs = parseInt(noOfArgs);

        var pleaseChooseTokens = [];
        for (i = 0; i < noOfArgs; i++) {
            var highlight = noOfArgs > 1 ? false : true;
            var pleaseChooseToken =  props.mode === 'template' ? getPleaseChooseSensor(null) : getPleaseChooseToken(highlight);
            if ( props.mode === 'sensor' ) {
                pleaseChooseToken = getPleaseChooseSensorName(null);
            }
            pleaseChooseTokens.push(pleaseChooseToken);
        }

        if (pleaseChooseTokens.length) {
            funcName1 = funcName1.replace('(n)', '(' + pleaseChooseTokens.join(',') + ')');
        } else {
            funcName1 = funcName1.replace('(n)', '(&nbsp;)');
        }
        return ' ' + funcName1;
    };

    const placeCaretAtEnd = (el) => {
        // contentEditable
        let range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        let selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
    };

    const positionMenuAtCaret = (menuContainer, cursorContext, activeQuery) => {
        if (cursorContext) {
            let textNode = cursorContext.textNode;
            const menuLeftEdgeCharaterPosition = Math.max(cursorContext.cursorCharacterPosition - activeQuery.length, 0);
            const range = document.createRange();
            range.setStart(textNode, menuLeftEdgeCharaterPosition);
            range.setEnd(textNode, menuLeftEdgeCharaterPosition);
            range.collapse(true);

            const marker = document.createElement('span');
            range.insertNode(marker);

            document.body.appendChild(menuContainer);
            containByScreen(menuContainer, marker, { position: 'bottom', hAlign: 'left' });
            marker.remove();

            cursorContext.textNodeParent.normalize();
        }
    };

    const pasteHtmlAtCaret = (html) => {
        if (setIsValidFormula) {
            setIsValidFormula(false);
        }
        var sel, range;
        if (window.getSelection) {
            sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                range = sel.getRangeAt(0);
                range.deleteContents();
                var el = document.createElement('div');
                el.innerHTML = html;
                var frag = document.createDocumentFragment(), node, lastNode;
                while ((node = el.firstChild)) {
                    lastNode = frag.appendChild(node);
                }
                range.insertNode(frag);

                if (lastNode) {
                    range = range.cloneRange();
                    range.setStartAfter(lastNode);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            }
        } 
        else if (document.selection && document.selection.type !== 'Control') {
            document.selection.createRange().pasteHTML(html);
        }
    };

    const syncModelVal = () => {
        if (innerEditor && innerEditor.current) {
            text.current = innerEditor.current.innerHTML;
            setContentEditableHtml(innerEditor.current.innerHTML);
        }
    };

    const setFocusOnEditor = ()=>{
        if (window.getSelection && window.getSelection() &&  window.getSelection().focusNode && window.getSelection().focusNode.id !== 'formula-editor' && window.getSelection().focusNode.parentElement.id !== 'formula-editor') {
            placeCaretAtEnd(innerEditor.current);
        }
    };

    const operatorClicked = (item) => {
        setFocusOnEditor();
        syncModelVal();
        var content = getFunctionPlaceholder(item.function);
        if (item.name === 'DayOfWeek') {
            content = getDayOfWeek(true);
        }
        else if (item.name === 'HourOfDay') {
            content = getHourOfDay(true);
        }
        else if (item.name === 'TimeOfDay') {
            content = getTimeOfDay(true);
        }
        pasteHtmlAtCaret(content);
    };

    const connectorsClicked = (e) => {
        const trackEnter = (e) => {
            let id = e.target.id;
            document.getElementById(id).setAttribute('value', e.target.value);
        };

        let key = getRandom();
        setFocusOnEditor();
        let val = e.target.textContent || e.target.getAttribute('data-key');
        if (val === 'VARIABLE') {
            val = props.mode === 'template' ? getPleaseChooseSensor(null) : getPleaseChooseToken(false);
            if ( props.mode === 'sensor' ) {
                val = getPleaseChooseSensorName(null);
            }
        }
        else if (val === 'CONSTANT') {
            val = getVariableToken(key);
            setTimeout(()=>{
                let textbx = document.getElementById(key);
                if (textbx) { 
                    textbx.focus();
                }
                textbx.addEventListener('input', trackEnter);
            }, 300);
        }
        pasteHtmlAtCaret(val);
        syncModelVal();
    };

    return (
        <div className="App">
            <div className={props.mode === 'formula' ? classes.EditorContainer : classes.TemplateEditorContainer}>
                {props.mode === 'formula'?
                    <div className={classes.TitleContainer}>
                        <div className={classes.inputs}>
                            <div className={classes.formRow}>
                                <FormControl className={classes.userInputWrapper} style={{width: 400}}>
                                    <TextField
                                        id="name"
                                        name="name"
                                        type="text"
                                        value={formik.values.name}
                                        label={<span>Formula Name<span className={classes.required}> *</span></span>}
                                        onChange={handleTitleChange}
                                        variant="outlined"
                                        size="small"
                                        InputLabelProps={{
                                            classes: {
                                                error:   classes.error,
                                                focused: classes.labelFocused,
                                                root:    classes.label
                                            }
                                        }}
                                        inputProps={{maxLength: 250}}
                                        InputProps={{
                                            onBlur:  formik.handleBlur,
                                            classes: {
                                                error:     classes.cssErrorUnderline,
                                                underline: classes.cssUnderline,
                                                root:      classes.input
                                            }
                                        }}
                                        FormHelperTextProps={{
                                            classes: {
                                                error: classes.error
                                            }
                                        }}
                                        error={Boolean(formik.errors.version) && Boolean(formik.touched.version)}
                                        helperText={Boolean(formik.touched.version) && formik.errors.version}
                                    />
                                </FormControl>
                            </div>  
                        </div>
                    </div> 
                    : 
                    ''
                }
                {props.mode === 'template' ?
                    <div className={classes.TitleContainer}>
                        <p className={classes.userFormTitleField}>Template</p>
                        <div className={classes.inputs}>
                            <div className={classes.formRow}>
                                <FormControl className={classes.userInputWrapper} style={{width: 200}}>
                                    <TextField
                                        id="templateName"
                                        name="templateName"
                                        type="text"
                                        value={formik.values.templateName}
                                        label={<span>Template Name<span className={classes.required}> *</span></span>}
                                        onChange={handleTitleChange}
                                        InputLabelProps={{
                                            classes: {
                                                error:   classes.error,
                                                focused: classes.labelFocused,
                                                root:    classes.label
                                            }
                                        }}
                                        inputProps={{maxLength: 250}}
                                        InputProps={{
                                            onBlur:  formik.handleBlur,
                                            classes: {
                                                error:     classes.cssErrorUnderline,
                                                underline: classes.cssUnderline,
                                                root:      classes.input
                                            }
                                        }}
                                        FormHelperTextProps={{
                                            classes: {
                                                error: classes.error
                                            }
                                        }}
                                        error={Boolean(formik.errors.version) && Boolean(formik.touched.version)}
                                        helperText={Boolean(formik.touched.version) && formik.errors.version}
                                    />
                                </FormControl>
                                {activeNavEquipment.id ?
                                    <FormControl className={classes.InputWrapper} style={{width: 200,marginLeft: 15}}>
                                        <InputLabel
                                            htmlFor="parent"
                                            classes={{
                                                error:   classes.Error,
                                                focused: classes.LabelFocused,
                                                root:    classes.Label
                                            }}
                                            error={Boolean(formik.errors.parent) && Boolean(formik.touched.parent)}
                                        >
                                            Equipment Type<span className={classes.Required}> *</span>
                                        </InputLabel>
                                        <Select
                                            value={formik.values.equipmentType}
                                            onChange={formik.handleChange}
                                            className={classes.Select}
                                            disabled={true}
                                            inputProps={{
                                                name:   'equipmentType',
                                                id:     'equipmentType',
                                                onBlur: formik.handleBlur
                                            }}
                                            error={Boolean(formik.errors.equipmentType) && Boolean(formik.touched.equipmentType)}
                                        >
                                            <MenuItem
                                                key={activeNavEquipment.equipmentType.id}
                                                value={activeNavEquipment.equipmentType.id}
                                            >
                                                {activeNavEquipment.equipmentType.name}
                                            </MenuItem>
                                        </Select>
                                        {formik.touched.equipmentType &&
                                    formik.errors.equipmentType && <FormHelperText className={classes.Error}>{formik.errors.equipmentType}</FormHelperText>}
                                    </FormControl>
                                    :
                                    <FormControl className={classes.inputWrapper} style={{ width: 200, marginLeft: 25,marginTop: 3 }}>
                                        <AutoComplete
                                            label="Equipment Type"
                                            name="equipmentType"
                                            onBlur={formik.handleBlur}
                                            onChange={(event, value) => handleDisplayUnitChange(event, value)}
                                            getOptionLabel={(option) => option.name || ''}
                                            getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                                            options={equipment1Types}
                                            error={Boolean(formik.errors.equipmentType) && Boolean(formik.touched.equipmentType)}
                                            helperText={Boolean(formik.errors.equipmentType) && Boolean(formik.touched.equipmentType) ? formik.errors.equipmentType : null}
                                            placeholder="Equipment Type"
                                            size="small"
                                            required  
                                            renderInput={(params) => <TextField {...params} label="Equipment Type" />}
                                        />
                                    </FormControl>
                                }
                                {activeNavEquipment.id ?
                                    <FormControl className={classes.InputWrapper} style={{width: 200,marginLeft: 15}}>
                                        <InputLabel
                                            htmlFor="parent"
                                            classes={{
                                                error:   classes.Error,
                                                focused: classes.LabelFocused,
                                                root:    classes.Label
                                            }}
                                            error={Boolean(formik.errors.parent) && Boolean(formik.touched.parent)}
                                        >
                                            Equipment<span className={classes.Required}> *</span>
                                        </InputLabel>
                                        <Select
                                            value={formik.values.parent}
                                            onChange={formik.handleChange}
                                            className={classes.Select}
                                            disabled={true}
                                            inputProps={{
                                                name:   'parent',
                                                id:     'parent',
                                                onBlur: formik.handleBlur
                                            }}
                                            error={Boolean(formik.errors.parent) && Boolean(formik.touched.parent)}
                                        >
                                            <MenuItem
                                                key={activeNavEquipment.id}
                                                value={activeNavEquipment.id}
                                            >
                                                {activeNavEquipment.name}
                                            </MenuItem>
                                        </Select>
                                        {formik.touched.parent && formik.errors.parent && 
                                            <FormHelperText className={classes.Error}>{formik.errors.parent}</FormHelperText>
                                        }
                                    </FormControl>
                                    :
                                    <FormControl className={classes.inputWrapper} style={{ width: 300, marginLeft: 25,marginTop: 3 }}>
                                        {
                                            <AutoComplete
                                                label="Equipment"
                                                name="parent"
                                                options={filteredEquipments}
                                                getOptionLabel={(option) => option.name || ''}
                                                getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}                                   
                                                onChange={handleEquipmentChange}
                                                size="small"
                                                required                                   
                                                renderInput={(params) => <TextField {...params} label="Equipment" />}
                                                renderOption={(props, option) => (
                                                    <li {...props}> {props.name}
                                                        <br />
                                                        {props.extendedData.client && props.extendedData.client.length > 0 && props.extendedData.site && props.extendedData.site.length > 0 ? 
                                                            <span style={{fontSize: '1rem', color: '#959595'}}>
                                                                {`${props.extendedData.client[0].name} - ${props.extendedData.site[0].name}`}
                                                            </span>:''}</li> )}
                                            />
                                        }
                                    </FormControl>
                                }
                            </div>  
                        </div>
                    </div>
                    : 
                    ''
                }
                {props.mode === 'sensor'?
                    <div className={classes.TitleContainer} />
                    : 
                    ''
                }
                <div id={'colContainer'} className={isCustom ? classes.CustomEditorColContainer : classes.EditorColContainer} style={props.mode === 'formula' ? {height: 'calc(100vh - 360px)', overflowY: 'auto'} : props.mode === 'sensor' ? {height: 'calc(100vh - 400px)', overflowY: 'auto'} : {height: 'calc(100vh - 555px)', overflowY: 'auto'}}>
                    <Operators operatorClicked={operatorClicked} />
                    <div className={`${classes.Editor} ${classes.Formulabuttons}`}>
                        <div style={props.mode === 'template'? {marginLeft: 0} : {}} className={classes.OperatorJoin}>
                            <div 
                                role={'none'} 
                                className={classes.CircleIcon} 
                                onClick={connectorsClicked}
                            >
                                <button><i data-key="+" className="fas fa-plus" /></button>
                            </div>
                            <div 
                                role={'none'} 
                                className={classes.CircleIcon} 
                                onClick={connectorsClicked}
                            >
                                <button><i data-key="-" className="fas fa-minus" /></button>
                            </div>
                            <div 
                                role={'none'} 
                                className={classes.CircleIcon} 
                                onClick={connectorsClicked}
                            >
                                <button><i data-key="*" className="fas fa-times" /></button>
                            </div>
                            <div 
                                role={'none'} 
                                className={`${classes.CircleIcon} margin-25`} 
                                onClick={connectorsClicked}
                            >
                                <button><i data-key="/" className="fas fa-divide" /></button>
                            </div>
                            <div 
                                role={'none'} 
                                style={{marginLeft: 15}} 
                                className={classes.CircleIcon} 
                                onClick={connectorsClicked}
                            >
                                <button><i data-key="=" className="fas fa-equals" /></button>
                            </div>
                            <div 
                                role={'none'} 
                                className={classes.CircleIcon} 
                                onClick={connectorsClicked}
                            >
                                <button><i data-key="!="  className="fas fa-not-equal" /></button>
                            </div>
                            <div 
                                role={'none'} 
                                className={classes.CircleIcon} 
                                onClick={connectorsClicked}
                            >
                                <button><i data-key="&lt;" className="fas fa-less-than" /></button>
                            </div>
                            <div 
                                role={'none'} 
                                className={`${classes.CircleIcon} ${classes.Margin25}`} 
                                onClick={connectorsClicked}
                            >
                                <button><i data-key="&gt;" className="fas fa-greater-than" /></button>
                            </div>
                            <div 
                                role={'none'} 
                                className={classes.CircleIcon} 
                                onClick={connectorsClicked}
                            >
                                <button><i data-key="(" className="fas fa-bracket-round1" /></button>
                            </div>
                            <div 
                                role={'none'} 
                                className={classes.CircleIcon} 
                                onClick={connectorsClicked}
                            >
                                <button><i data-key=")" className="fas fa-bracket-round2" /></button>
                            </div>
                            <div 
                                role={'none'} 
                                className={classes.CircleIcon} 
                                onClick={connectorsClicked}
                            >
                                <button><i data-key="," className="fas fa-bracket-comma" /></button>
                            </div>
                            <div 
                                role={'none'} 
                                style={{marginLeft: 15}} 
                                className={classes.SquareIcon} 
                                onClick={connectorsClicked}
                            >
                                <button>VARIABLE</button>
                            </div>
                            <div 
                                role={'none'} 
                                className={classes.SquareIcon} 
                                onClick={connectorsClicked}
                            >
                                <button>CONSTANT</button>
                            </div>
                        </div>
                        {props.mode === 'sensor' ?
                            <div className="ccb-editor-container" style={props.mode === 'formula' ? {marginLeft: 15} : {}}>
                                <ContentEditable
                                    id="formula-editor"
                                    disabled={false} 
                                    innerRef={innerEditor} 
                                    style={{ height: 'calc(100vh - 464px)',fontSize: 15 }}
                                    html={text.current}
                                    onFocus={handleFocus} 
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                />
                            </div>:
                            <div className="ccb-editor-container" style={props.mode === 'formula' ? {marginLeft: 15} : {}}>
                                <ContentEditable
                                    id="formula-editor"
                                    disabled={false} 
                                    innerRef={innerEditor} 
                                    style={props.mode === 'formula' ? { height: 'calc(100vh - 410px)', fontSize: 15 } : { height: 'calc(100vh - 600px)', fontSize: 15 }}
                                    html={text.current}
                                    onFocus={handleFocus} 
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className={`menu-cont ${classes.MenuCont} ${isOpen ? 'menu-visible-formula' : ''} ${isOpen ? '' : classes.Hidden}`}>
                <div className={classes.MenuContainer}>
                    <ul className={classes.Popup}>
                        {variableList.map((item, index) => (
                            <li className="menu-item" key={index}>{item}</li>
                        ))}
                        <li>
                            <input type="text" placeholder="Press Enter to Add" className={`variable-input ${classes.VariableInput}`} />
                        </li>
                    </ul>
                </div>
            </div>
            <div className={`menu-cont-sensor ${classes.MenuCont} ${isSensorOpen ? 'menu-visible-sensor' : ''} ${isSensorOpen ? '' : classes.Hidden}`}>
                {props.mode === 'sensor'?
                    <div className={classes.MenuContainer}>
                        {activeNavEquipment && activeNavEquipment.extendedData && activeNavEquipment.extendedData.sensors && activeNavEquipment.extendedData.sensors.length > 0 ?
                            <React.Fragment>
                                <ul className={classes.Popup}>
                                    {activeNavEquipment.extendedData.sensors.map((item, index) => (
                                        <li className="menu-item menu-item-sensor" data-id={item.id} key={index}>{item.name}</li>
                                    ))}
                                </ul>
                                <ul className={classes.Popup}>
                                    <li className="menu-item menu-item-sensor" data-id={'add'} key={'add'}>
                                        <i data-key="+" className="fas fa-plus" style={{marginTop: 5, marginRight: 10}} />
                                        Add External Sensor
                                    </li>
                                </ul>
                            </React.Fragment>
                            :
                            <ul className={classes.Popup}>
                                <li className="menu-item">No results found</li>
                            </ul>
                        }
                    </div>:
                    <div className={classes.MenuContainer}>
                        {filteredSensorTypes && filteredSensorTypes.length> 0 ?
                            <React.Fragment>
                                <ul className={classes.Popup}>
                                    {filteredSensorTypes.map((item, index) => (
                                        <li className="menu-item menu-item-sensor" data-id={item.id} key={index}>{item.name}</li>
                                    ))}
                                </ul>
                                <ul className={classes.Popup}>
                                    <li className="menu-item menu-item-sensor" data-id={'add'} key={'add'}>
                                        <i data-key="+" className="fas fa-plus" style={{marginTop: 5, marginRight: 10}} />
                                        Add External Sensor
                                    </li>
                                </ul>
                            </React.Fragment>
                            :
                            <ul className={classes.Popup}>
                                <li className="menu-item">No results found</li>
                            </ul>
                        }
                    </div>
                }
            </div>
            <div className={`menu-cont-week ${classes.MenuCont} ${isDayOpen ? '' : classes.Hidden}`}>
                <div className={classes.MenuContainer}>
                    <ul className={classes.Popup}>
                        {weekList.map((item, index) => (
                            <li className="menu-item" key={index}>{item}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className={`menu-cont-hour ${classes.MenuCont} ${isHourOpen ? '' : classes.Hidden}`}>
                <div className={classes.MenuContainer}>
                    <ul className={classes.Popup}>
                        {timeList.map((item, index) => (
                            <li className="menu-item" key={index}>{item}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className={`menu-cont-minute ${classes.MenuCont} ${isMinuteOpen ? '' : classes.Hidden}`}>
                <div className={classes.MenuContainer}>
                    <ul className={classes.Popup}>
                        {minuteList.map((item, index) => (
                            <li className="menu-item" key={index}>{item}</li>
                        ))}
                    </ul>
                </div>
            </div>
            {externalSensorOpen ?
                <React.Fragment> 
                    {props.mode === 'sensor'?
                        <BobModal
                            confirmText="Ok"
                            cancelText="Cancel"
                            rootClass={'external-sensor-modal external-sensor-modal1'}
                            onCancel={handleConfirmation}
                            onClose={handleConfirmation}
                            onConfirm={submitFormula}
                            open={externalSensorOpen}
                            title={'Universe'}
                        >
                            <div className={classes.formRow}>
                                <span className={classes.LblField}>Site</span>
                                <span className={classes.LblFieldDark}>{activeNavSite ? activeNavSite.name : ''}</span>
                            </div>
                            <div style={{marginTop: 20}} className={classes.formRow}>
                                <TextField
                                    id="outlined-basic"
                                    label="Equipment/System"
                                    variant="outlined"
                                    disabled={!activeNavEquipment.id}
                                    size="small"
                                    value={autoCompleteValue}
                                    onChange={e => {
                                        setAutoCompleteValue(e.target.value);
                                    }}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">{loading ? <CircularProgress size={10} /> : <i onClick={() => clearSearch()} role="none" className={`fas fa-times ${classes.ClearButton}`} />}</InputAdornment>
                                    }}
                                    onClick={handleClick}
                                    className={classes.TextField}
                                />
                                <Popper
                                    id={id}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                >
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <Paper
                                            className={classes.Popper}
                                            square
                                        >
                                            <div className={classes.List}>
                                                {
                                                    !isEmpty(entities) ?
                                                        <List>
                                                            {entities.map((item, index) => (
                                                                <ListItem
                                                                    key={index}
                                                                    onClick={() => handleEntityChangeSensor(item)}
                                                                    classes={{
                                                                        root: classes.ListItem
                                                                    }}
                                                                >
                                                                    {item.name}
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                        :
                                                        <List>
                                                            <ListItem
                                                                key={0}
                                                                classes={{
                                                                    root: classes.ListItem
                                                                }}
                                                            >
                                                                No Equipment or Systems found...
                                                            </ListItem>
                                                        </List>
                                                }
                                            </div>
                                        </Paper>
                                    </ClickAwayListener>
                                </Popper>
                            </div>
                            <FormControl className={classes.formRow} style={{ width: '100%', marginTop: 20, paddingRight: 20 }}>
                                <AutoComplete1
                                    grouped
                                    label="Sensor Type"
                                    name="sensorType1"
                                    onBlur={formik.handleBlur}
                                    onChange={handleSensorTypeChange1}
                                    options={filteredExtSensorTypes}
                                    placeholder="Sensor Type"
                                    disabled={false}
                                    value={formik.values.sensorType1}
                                    error={Boolean(formik.errors.sensorType) && Boolean(formik.touched.sensorType)}
                                    helperText={Boolean(formik.touched.sensorType) && formik.errors.sensorType}
                                />
                            </FormControl>
                            <FormControl className={classes.formRow} style={{ width: '100%', marginTop: 20, paddingRight: 20 }}>
                                <AutoComplete1
                                    label="Sensors"
                                    name="sensorType2"
                                    onBlur={formik.handleBlur}
                                    onChange={handleSensorChange1}
                                    options={esensors}
                                    placeholder="Sensors"
                                    value={formik.values.sensor}
                                    error={Boolean(formik.errors.sensorType) && Boolean(formik.touched.sensorType)}
                                    helperText={Boolean(formik.touched.sensorType) && formik.errors.sensorType}
                                />
                            </FormControl>
                        </BobModal>
                        :
                        <BobModal
                            confirmText="Ok"
                            cancelText="Cancel"
                            rootClass={'external-sensor-modal'}
                            onCancel={handleConfirmation}
                            onClose={handleConfirmation}
                            onConfirm={submitFormula}
                            open={externalSensorOpen}
                            title={'Universe'}
                        >
                            <div className={classes.formRow}>
                                <FormControl className={classes.formRow} style={{ width: '100%', marginBottom: 20, paddingRight: 20 }}>
                                    <InputLabel
                                        htmlFor="site"
                                        classes={{
                                            error:   classes.Error,
                                            focused: classes.LabelFocused,
                                            root:    classes.Label
                                        }}
                                        error={Boolean(formik.errors.site) && Boolean(formik.touched.site)}
                                    >
                                        Site<span className={classes.Required}> *</span>
                                    </InputLabel>
                                    <Select
                                        value={formik.values.site}
                                        onChange={handleSiteChange}
                                        className={classes.Select}
                                        error={Boolean(formik.errors.displayDataType) && Boolean(formik.touched.displayDataType)}
                                    >
                                        {
                                            navSites.map(objectItem =>
                                                <MenuItem
                                                    key={objectItem.id}
                                                    value={objectItem.id}
                                                >
                                                    {objectItem.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                            </div>
                            <div style={{marginTop: 20}} className={classes.formRow}>
                                <TextField
                                    id="outlined-basic"
                                    label="Equipment/System"
                                    variant="outlined"
                                    disabled={!activeNavEquipment.id}
                                    size="small"
                                    value={autoCompleteValue}
                                    onChange={e => {
                                        setAutoCompleteValue(e.target.value);
                                        debouncedFetch(e.target.value);
                                    }}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">{loading ? <CircularProgress size={10} /> : <i onClick={() => clearSearch()} role="none" className={`fas fa-times ${classes.ClearButton}`} />}</InputAdornment>
                                    }}
                                    onClick={handleClick}
                                    className={classes.TextField}
                                />
                                <Popper
                                    id={id}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                >
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <Paper
                                            className={classes.Popper}
                                            square
                                        >
                                            <div className={classes.List}>
                                                {
                                                    !isEmpty(entities) ?
                                                        <List>
                                                            {entities.map((item, index) => (
                                                                <ListItem
                                                                    key={index}
                                                                    onClick={() => handleEntityChange(item)}
                                                                    classes={{
                                                                        root: classes.ListItem
                                                                    }}
                                                                >
                                                                    {item.name}
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                        :
                                                        <List>
                                                            <ListItem
                                                                key={0}
                                                                classes={{
                                                                    root: classes.ListItem
                                                                }}
                                                            >
                                                                No Equipment or Systems found...
                                                            </ListItem>
                                                        </List>
                                                }
                                            </div>
                                        </Paper>
                                    </ClickAwayListener>
                                </Popper>
                            </div>
                            <FormControl className={classes.formRow} style={{ width: '100%', marginTop: 20, paddingRight: 20 }}>
                                <AutoComplete1
                                    grouped
                                    label="Sensor Type"
                                    name="sensorType"
                                    onBlur={formik.handleBlur}
                                    onChange={handleSensorTypeChange}
                                    options={filteredExtSensorTypes}
                                    placeholder="Sensor Type"
                                    value={formik.values.sensorType}
                                    error={Boolean(formik.errors.sensorType) && Boolean(formik.touched.sensorType)}
                                    helperText={Boolean(formik.touched.sensorType) && formik.errors.sensorType}
                                />
                            </FormControl>
                        </BobModal>
                    }
                </React.Fragment>
                : 
                ''
            }
        </div>
    );
};

const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents } = basAgent;

    return {
        activeNavEquipment: state.bob.activeNavEquipment,
        activeNavClient:    state.bob.activeNavClient,
        activeNavCompany:   state.bob.activeNavCompany,
        activeNavSite:      state.bob.activeNavSite,
        agents:             Object.values(basAgents),
        bobLoading:         state.bob.bobLoading,
        activeFormula:      state.dashboard.activeFormula,
        activeTemplate:     state.dashboard.activeTemplate,
        navEquipment:       state.bob.navEquipment,
        sensorTypes:        state.sensorTypes.data,
        equipmentTypes:     state.equipmentTypes.data,
        navSites:           state.bob.navSites,
        equipment:          state.k2aCore.equipment,
        clonedFormula:      state.dashboard.clonedFormula,
        configEntities:     state.dashboard.configEntities,
        entitySensors:      state.reporting.entitySensors
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...DashboardActions,
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...BasAgentActions,
    ...DashboardActions,
    ...DeviceActions,
    ...UiActions,
    ...SensorTypeActions,
    ...EquipmentTypeActions,
    ...K2ACoreActions,
    ...reportingActions,
    fetchEquipmentTypesLookup
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FormulaBuilder));
